module.exports = __webpack_public_path__ + "static/media/admin_unselected.37ccc437.svg";